import React from 'react';
import LayoutSimple from '../components/layout/LayoutSimple';
import { motion } from 'framer-motion';

const RefundPolicy = () => {
  return (
    <LayoutSimple>
      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white shadow-xl rounded-2xl p-8 md:p-12 border border-blue-50"
        >
          <h1 className="text-4xl font-extrabold text-slate-900 mb-8 border-b pb-4">Refund Policy</h1>
          
          <div className="space-y-6 text-slate-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">1. Subscription Billing</h2>
              <p>Subscriptions are billed in advance on a monthly or yearly basis. Payments are non-refundable except where required by law.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">2. Cancellation</h2>
              <p>You may cancel your subscription at any time through the billing settings. Upon cancellation, your service will remain active until the end of the current billing cycle. No partial refunds will be provided for early cancellation.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">3. No-Questions-Asked Window</h2>
              <p>For new subscriptions, we offer a 7-day money-back guarantee. If you are unsatisfied with our CRM for any reason, contact us within 7 days of your first payment for a full refund.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-slate-800 mb-3">4. Refund Processing</h2>
              <p>Approved refunds will be processed within 5-7 business days and credited back to the original payment method used during purchase.</p>
            </section>

            <p className="text-sm pt-8 border-t text-slate-400">Last updated: April 2026</p>
          </div>
        </motion.div>
      </div>
    </LayoutSimple>
  );
};

export default RefundPolicy;
